import firebase from "firebase";
import "firebase/firestore";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import {
    firebaseStateReducer,
    getFirebase,
    reactReduxFirebase,
} from "react-redux-firebase";
import {
    applyMiddleware,
    combineReducers,
    compose as composeRaw,
    createStore,
} from "redux";
import {
    firestoreReducer,
    reduxFirestore,
} from "redux-firestore";
import thunkMiddleware from "redux-thunk";
import {
    bootstrap,
    newVersionAvailable,
    refreshMessagingToken,
} from "./actions";
import App from "./App";
import "./index.css";
import LoginValve from "./LoginValve";
import {
    activeContext,
    contextFilter,
    documentReferences,
    emulatePlayer,
    messagingToken,
    outOfDate,
} from "./reducers";
import registerServiceWorker from "./registerServiceWorker";
import "./styles/components/button.css";
import "./styles/components/container.css";
import "./styles/components/dimmer.css";
import "./styles/components/divider.css";
import "./styles/components/dropdown.css";
import "./styles/components/form.css";
import "./styles/components/grid.css";
import "./styles/components/header.css";
import "./styles/components/icon.css";
import "./styles/components/image.css";
import "./styles/components/input.css";
import "./styles/components/item.css";
import "./styles/components/label.css";
import "./styles/components/loader.css";
import "./styles/components/menu.css";
import "./styles/components/message.css";
import "./styles/components/reset.css";
import "./styles/components/segment.css";
import "./styles/components/site.css";
import "./styles/components/table.css";
import "./styles/components/transition.css";

// Initialize Firebase
firebase.initializeApp({
    apiKey: "AIzaSyClaPJPnO99wIeQ-DXnaI88x5MVDqMAhKE",
    authDomain: "the-economy-c291f.firebaseapp.com",
    databaseURL: "https://the-economy-c291f.firebaseio.com",
    projectId: "the-economy-c291f",
    storageBucket: "the-economy-c291f.appspot.com",
    messagingSenderId: "1083207475571",
});
firebase.firestore();

const compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || composeRaw;
const rootReducer = combineReducers({
    activeContext,
    emulatePlayer,
    firebase: firebaseStateReducer,
    firestore: firestoreReducer,
    messagingToken,
    outOfDate,
    docs: documentReferences,
    contextFilter,
});
const middlewares = applyMiddleware(
    thunkMiddleware.withExtraArgument(getFirebase),
);
// noinspection JSUnusedGlobalSymbols
const store = createStore(rootReducer, compose(
    middlewares,
    reactReduxFirebase(firebase, {
        userProfile: "users",
        updateProfileOnLogin: false,
        useFirestoreForProfile: true,
        profileFactory: auth => ({
            displayName: auth.displayName,
            email: auth.email,
            photoURL: auth.photoURL,
        }),
        // enableLogging: true,
    }),
    reduxFirestore(firebase),
));

store.dispatch(bootstrap());

const messaging = firebase.messaging();
messaging.onTokenRefresh(() => store.dispatch(refreshMessagingToken()));
messaging.onMessage(payload => console.log("Foreground message received", payload)); // eslint-disable-line no-console

window.__app_update_available = () =>
    store.dispatch(newVersionAvailable());

ReactDOM.render(
    <Provider store={store}>
        <LoginValve>
            <App />
        </LoginValve>
    </Provider>
    , document.getElementById("app"),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js